(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["gap-web-it-portal-app"] = factory();
	else
		root["gap-web-it-portal-app"] = factory();
})(window, function() {
return 